/**
 * Maps any nested route to its module list page so the global Back button
 * always lands on the module the user is working in (never an unrelated
 * previous history entry). Only real routes are listed here, so the result is
 * always a valid destination.
 */
const LIST_ROUTES = [
  "/setup/accounts",
  "/setup/cost-centers",
  "/setup/asset-groups",
  "/setup/fiscal-periods",
  "/setup/product-categories",
  "/setup/warehouses",
  "/setup/damage-reasons",
  "/settings/roles",
  "/inventory/issues",
  "/inventory/srn",
  "/inventory/transfers",
  "/inventory/damages",
  "/inventory/stock-take",
  "/inventory/period-close",
  "/journal",
  "/vouchers/payment",
  "/vouchers/receipt",
  "/assets",
  "/prepaid",
  "/cip",
  "/accruals",
  "/cash-count",
  "/cash-custody",
  "/leases",
  "/sales/customers",
  "/sales/products",
  "/sales/invoices",
  "/sales/orders",
  "/purchases/vendors",
  "/purchases/orders",
  "/purchases/invoices",
  "/support",
  "/admin/help",
] as const;

/** Deepest list route that is a strict ancestor of `pathname`, else null. */
export const moduleListPath = (pathname: string): string | null => {
  let best: string | null = null;
  for (const r of LIST_ROUTES) {
    if (pathname.startsWith(r + "/") && (best === null || r.length > best.length)) best = r;
  }
  return best;
};
